import { h, render } from 'preact';
import { useId, useState } from 'preact/hooks';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'utils/image';
import clsx from 'clsx';
import ArrowLeft from '../utils/icon/arrow-left.svg';
import ArrowRight from '../utils/icon/arrow-right.svg';

export default (element, data) => {
  const V5050Product = ({
    slides = [],
    cta,
    headingSize = 'v-h4',
  }) => {
    const id = useId();
    const [activeIndex, setActiveIndex] = useState(0);
    const slidesWithImages = slides.filter(slide => slide.image);
    const activeSlide = slidesWithImages[activeIndex || 0];
    const eyebrow = activeSlide?.eyebrow;
    const title = activeSlide?.title;
    const description = activeSlide?.description;
    const ctaUrl = activeSlide?.product?.url;
    const ctaLabel = cta?.label;

    return (
      <div id={id} className='grid grid-cols-1 gap-y-5'>
        {eyebrow && (
          <div className='v-eyebrow-lg text-center'>
            {eyebrow}
          </div>
        )}
        {title && (
          <div
            className={clsx(
              headingSize,
              'break-words text-center',
            )}
          >
            {title}
          </div>
        )}
        <div className='relative px-[38px] laptop:px-[49px] [&_.swiper-wrapper]:items-center'>
          <Swiper
            loop={false}
            modules={[Navigation]}
            navigation={{
              nextEl: `#${id} .swiper-button-next`,
              prevEl: `#${id} .swiper-button-prev`,
            }}
            slidesPerView={1}
            onSlideChange={swiper => {
              setActiveIndex(swiper.realIndex);
            }}
            onInit={swiper => {
              setActiveIndex(swiper.realIndex || 0);
            }}
          >
            {
              slidesWithImages.map((slide, index) => {
                const { image } = slide;
                return image && (
                  <SwiperSlide key={index}>
                    <Image
                      url={image}
                      classes="w-full h-auto block"
                    />
                  </SwiperSlide>
                )
              })
            }
          </Swiper>

          <div className='absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-between z-[5] pointer-events-none'>
            <button className='swiper-button-prev after:!content-[none] !relative !h-[35px] !inset-auto !w-[35px] !text-black bg-transparent border border-[#0000004d] rounded-full !mt-0 pointer-events-auto'>
              <ArrowLeft />
            </button>
            <button className='swiper-button-next after:!content-[none] !relative !h-[35px] !inset-auto !w-[35px] !text-black bg-transparent border border-[#0000004d] rounded-full !mt-0 pointer-events-auto'>
              <ArrowRight />
            </button>
          </div>
        </div>
        {description && (
          <div
            className='font-14 leading-5 rte text-center'
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {ctaUrl && ctaLabel && (
          <div className='text-center'>
            <a
              href={ctaUrl}
              className={clsx(
                'link-unstyled cursor-pointer inline-block w-auto min-w-[251px]',
                cta?.class,
              )}
            >
              {ctaLabel}
            </a>
          </div>
        )}
      </div>
    )
  }

  const init = () => {
    const container = element.querySelector('[data-section-render]');
    if (!container) return;

    render(<V5050Product {...data} />, container);
  };

  init();
};